import React from "react";
import formStyle from "./formStyle.module.css";
import Logo from "../../styles/svg/wpu/wpuLogoNoTitle.svg";
import CopyRightFooter from "../CopyRightFooter/CopyRightFooter.jsx";
import toUserSite from "../auxiliary/toUserSite";
import GeneralHeader from "../GeneralHeader/GeneralHeader";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/userContext.js";


const SignupForm = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();


  const validate = (values) => {
    const errors = {};
    if (!values.fullName) {
      errors.fullName = "هذا الحقل مطلوب...";
    } else if (values.fullName.length < 4) {
      errors.fullName = "يجب ان يكون 4 حرفاً أو اكثر";
    } else setUser(values.fullName);

    if (!values.password) {
      errors.password = "هذا الحقل مطلوب...";
    } else if (values.password.length < 10) {
      errors.password = "يجب أن تكون 10 حروف على الأقل";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      fullName: "",
      password: "",
      user:""
    },
    validate,
    // onChange: (values)=>{
    //   alert(JSON.stringify(values, null, 2));
    // },
    onSubmit: (values) => {
      setUser(values.fullName);
      localStorage.setItem("user",user)
    },
  });

  const onSubmit = (e) => {
      e.preventDefault();
      formik.handleSubmit();
      navigate(toUserSite(user));
  }

  return (
    <>
      <div className="appContainer">
        <header className="appHeader">
          <GeneralHeader/>
        </header>
        <main className="appBody">
          <div className={formStyle.wpuformcontainer}>
            <div className={formStyle.wpuformlogocontainer}>
              <img src={Logo} alt="LOGO" className={formStyle.wpulogo} />
            </div>
            <h1 className={formStyle.formtitle}>الدخول الى الموقع</h1>
            <form className={formStyle.wpuform} onSubmit={onSubmit}>
              <div className={formStyle.wpusubform}>
                <label htmlFor="fullName" className={formStyle.wpulabel}>
                  الإسم الكامل
                </label>
                <input
                  id="fullName"
                  name="fullName"
                  placeholder="الإسم الكامل"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.fullName}
                  className={formStyle.wpuinput}
                />
                {formik.errors.fullName ? (
                  <div className={formStyle.wpup}>{formik.errors.fullName}</div>
                ) : null}
                </div>
              <div className={formStyle.wpusubform}>
                <label htmlFor="password" className={formStyle.wpulabel}>
                  كلمة السر
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="true"
                  onChange={formik.handleChange}
                  value={formik.values.password}
                  className={formStyle.wpuinput}
                />
                {formik.errors.password ? (
                  <div className={formStyle.wpup}>{formik.errors.password}</div>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: ".5rem",
                  justifyContent: "flex-end",
                }}
              >
                <button type="submit" className={formStyle.wpubutton}>
                  إرسال
                </button>
              </div>
            </form>
          </div>
        </main>
        <footer className="appFooter"> <CopyRightFooter /> </footer>
      </div>
    </>
  );
};

export default SignupForm;
